import { fmtDate } from "../../extensions/utils";
import { Tag } from "antd";
import { isMobile } from "../../extensions/design";
import { SportTooltip } from "../../controls";
import { TeamOutlined, UserOutlined } from "@ant-design/icons";

const clientItemTagHex = (raw) => {
  if (raw == null || raw === "") return null;
  const s = String(raw).trim();
  return s.startsWith("#") ? s : `#${s}`;
};

// Значки роли в группе: представитель - двое, участник группы - один
const ClientItemRoleIcons = ({ item }) => {
  if (!item?.isRepresentative && !item?.isFamilyMember) return null;
  return (
    <>
      {item.isRepresentative && (
        <SportTooltip title="Представитель группы" placement="top">
          <span className="client-role-icon client-role-icon_representative">
            <TeamOutlined />
          </span>
        </SportTooltip>
      )}
      {item.isFamilyMember && (
        <SportTooltip title="Участник группы" placement="top">
          <span className="client-role-icon client-role-icon_family">
            <UserOutlined />
          </span>
        </SportTooltip>
      )}
    </>
  );
};

const ClientItem = ({ item, onClick }) => {
  const getImage = () => {
    return <img className="client-photo" src={item?.imageId ? `${process.env.REACT_APP_API_BASE_URL}/api/image/${item.imageId}.jpg` : "/images/sample.png"} alt="client"/>
  }

  return<div className={`client-item${item.deleted ? ' deleted-client' : ''}`} onClick={onClick}>
    <div className="client-item-photo">{getImage()}</div>
    <div className="client-item-body">
      <div className="client-item-line-bold-double">
        <div className="client-item-clip client-item-name-with-tags">
          <div className="client-item-name-row">
            <span className="client-item-name">{item.name}</span>
          </div>
          <span className="client-item-tag-row">
            {/* Значки роли - в том же ряду, что и теги клиента */}
            <ClientItemRoleIcons item={item} />
            {(Array.isArray(item.tags) ? item.tags : []).map((t) => {
              const hex = clientItemTagHex(t.color);
              return (
                <Tag
                  key={t.id}
                  className="client-item-tag-chip"
                  style={{
                    height: 14,
                    marginInlineEnd: 4,
                    fontSize: 11,
                    lineHeight: "16px",
                    ...(hex ? { backgroundColor: hex, borderColor: hex, color: "#fff" } : {}),
                  }}
                >
                  {t.value ?? ""}
                </Tag>
              );
            })}
          </span>
        </div>
        <div className="client-item-clip-right">{item.phone}</div>
      </div>
      <div className="client-item-line-triple">
        <div className="client-item-clip">Карта: {item.card}</div>
        <div className="client-item-clip">Д.р: {fmtDate(item.dateBirth)}</div>
        <div className="client-item-clip client-item-debt"> {isMobile ? "" : "Долг:" } {item.dolg}</div>
        {/* <div style={{textAlign: "center"}}>{item.keyName}</div> */}
      </div>
    </div>
  </div>
}

export default ClientItem;